import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, Link2, CheckCircle2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { epostaMerkez } from "../lib/api";

export default function SigortaDosyaEpostaSection({ dosyaId, dosyaNo }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        if (!dosyaId) return;
        setLoading(true);
        try {
            const data = await epostaMerkez.dosyaEpostalar(dosyaId);
            setItems(data.items || []);
        } catch {
            setItems([]);
        } finally {
            setLoading(false);
        }
    }, [dosyaId]);

    useEffect(() => {
        load();
    }, [load]);

    async function applyRow(row) {
        try {
            await epostaMerkez.apply(row.id, dosyaId);
            toast.success("Talep / referans dosyaya işlendi.");
            load();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Onay kaydedilemedi.");
        }
    }

    return (
        <section className="mb-8 rounded-xl border border-white/10 bg-[#121A2F] p-5">
            <div className="flex flex-wrap items-center gap-2 mb-4">
                <Mail className="h-5 w-5 text-[#D4AF37]" />
                <h2 className="font-display text-lg text-white">Dosya E-postaları</h2>
                <span className="text-xs text-slate-500 font-mono">{dosyaNo}</span>
                <Link
                    to="/yeni/eposta-merkezi"
                    className="ml-auto text-xs text-[#D4AF37] hover:underline inline-flex items-center gap-1"
                >
                    E-posta Merkezi <ExternalLink className="h-3 w-3" />
                </Link>
            </div>
            {loading ? (
                <div className="flex justify-center py-8">
                    <Loader2 className="h-6 w-6 animate-spin text-[#D4AF37]" />
                </div>
            ) : items.length === 0 ? (
                <p className="text-sm text-slate-500 text-center py-6">
                    Bu dosyaya bağlı e-posta yok. E-posta Merkezinden «Bağla ve onayla» ile ekleyin.
                </p>
            ) : (
                <ul className="space-y-2">
                    {items.map((row) => (
                        <li
                            key={row.id}
                            className="p-3 rounded-lg border border-white/10 bg-[#0B0F19]/60"
                        >
                            <div className="text-sm font-medium text-slate-200 truncate">
                                {row.subject || "(Konu yok)"}
                            </div>
                            <div className="text-xs text-slate-500 mt-1 truncate">{row.from_email}</div>
                            <p className="text-xs text-slate-400 mt-2 line-clamp-3 whitespace-pre-wrap">
                                {row.body_snippet}
                            </p>
                            <div className="flex flex-wrap gap-2 mt-2 items-center">
                                <span className="text-[10px] uppercase px-1.5 py-0.5 rounded bg-sky-500/20 text-sky-200">
                                    {row.mailbox}
                                </span>
                                {row.sigorta_talep_no && (
                                    <button
                                        type="button"
                                        onClick={() => applyRow(row)}
                                        className="text-[10px] px-2 py-1 rounded border border-emerald-500/40 text-emerald-200 hover:bg-emerald-500/10 inline-flex items-center gap-1"
                                    >
                                        <CheckCircle2 className="h-3 w-3" />
                                        Onayla
                                    </button>
                                )}
                                <Link
                                    to={`/yeni/eposta-merkezi`}
                                    state={{ epostaId: row.id }}
                                    className="text-[10px] text-[#D4AF37] hover:underline ml-auto"
                                >
                                    Merkezde aç →
                                </Link>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
}
